/*@flow*/
import React, { useState, createRef } from 'react';
import { EmailT, PasswordT } from 'types/tcomb';
import * as t from 'lib/t';
import { set, unset } from 'ops';
import qs from 'qs';
import api from 'lib/api';
import { Fields } from 'lib/proforma';
import textbox from 'lib/proforma/templates/Textbox';
import PATHS from 'const/paths';
import Turbolinks from 'turbolinks';

const passwordTemplate = textbox.clone({
  Input: (locals) => {
    return (
      <div>
        <input {...locals.attrs} />
        <p className="text-right">
          <a onClick={goToPasswordReset}>Forgot?</a>
        </p>
      </div>
    );
  },
});

const ErrorsView = ({ errors }) =>
  errors && errors.length > 0 ? (
    <ul
      data-testid="ErrorsView"
      className="alert alert-danger list-unstyled pb-1"
    >
      {errors.map((e, i) => (
        <li key={i}>{e}</li>
      ))}
    </ul>
  ) : null;

const goToPasswordReset = () => set('mode.gatewayModal.type', 'PasswordReset');

const schema = t.struct({
  sign_in: t
    .struct({
      email: EmailT.options({ type: 'email' }),
      password: PasswordT.options({
        type: 'password',
        template: passwordTemplate,
      }),
    })
    .options({
      legend: '',
    }),
});

type Record = { [key: string]: string };

type FormValue = { sign_in: Record };

type PropsT = {
  errors?: string[],
  value?: FormValue,
  isLoading?: boolean,
};

const Component = (props: PropsT) => {
  const [value, setValue] = useState(props.value || { sign_in: {} });
  const [errors, setErrors] = useState(props.errors || []);
  const [isLoading, setLoading] = useState(Boolean(props.isLoading));

  const formRef = createRef();
  const tFormRef = createRef();
  const submitBtn = createRef();

  const login = (body) => {
    setLoading(true);
    const onSuccess = () => {
      unset(PATHS.activeModal);
      Turbolinks.visit('/map');
    };
    const onError = (v) => {
      setLoading(false);
      setErrors(v.errors || ['Unknown error']);

      // if (v.errors) {
      //   setErrors(v.errors);
      // } else {
      //   onSuccess();
      // }
    };

    api
      .fetchJson('/users/sign_in', {
        method: 'POST',
        body,
      })
      .then(onSuccess)
      .catch(onError);
  };

  const onSubmit = (e) => {
    e.preventDefault();
    const form = formRef.current;
    const tForm = tFormRef.current;
    if (!form) return;
    if (!tForm) return;
    const v = qs.parse($(form).serialize());

    const res = t.validate(v, schema);

    // Note: we validate twice because tcomb-form does not
    // see auto-filled values. Hence we first take them from html
    // and validate them, and the second time is to show validation
    // errors on the form.
    if (res && res.errors.length > 0) {
      tForm.validate();
      return;
    }
    if (!v.sign_in) return;

    login({ user: v.sign_in });
  };

  return (
    <form
      data-testid="SignInForm"
      className="signInForm mt-4"
      onSubmit={(e) => onSubmit(e)}
      id="signInForm"
      ref={formRef}
    >
      <ErrorsView errors={errors} />
      <Fields
        ref={tFormRef}
        type={schema}
        value={value}
        onChange={(v) => {
          setValue(v);
        }}
      />
      <button
        ref={submitBtn}
        data-testid="SubmitBtn"
        type="submit"
        className="btn btn-block btn-primary"
        onClick={(e) => onSubmit(e)}
        disabled={isLoading}
      >
        {isLoading ? 'Please wait...' : 'Sign in'}
      </button>
    </form>
  );
};

export default (Component: any);
